import { m } from 'framer-motion'
import cx from 'classnames'
import { hasObject } from '@lib/helpers'
import React, { useState } from 'react'
import axios from 'axios'
import Link from 'next/link'

import { ProductPrice, ProductTileThumbnail } from '@blocks/product'
import { useI18nContext } from '@lib/i18n'
import Photo from '@components/photo'
import { canonicalUrl } from '@components/link'

// setup our inventory fetcher
const fetchInventory = (url, id) => {
  return axios
    .get(url, {
      params: {
        id: id,
      },
    })
    .then((res) => {
      return res.data
    })
    .catch((e) => console.log('error', e))
}

const ProductCard = ({ product, index, className }) => {
  if (!product) return null

  // find default variant for product
  const defaultVariant = product.variants?.find((v) => {
    const option = {
      name: product.options[0]?.name,
      value: product.options[0]?.values[0],
      position: product.options[0]?.position,
    }
    return hasObject(v.options, option)
  })

  // set active variant as default
  const [activeVariant, setActiveVariant] = useState(
    defaultVariant ? defaultVariant : product.variants[0]
  )

  return (
    <m.div
      initial="initial"
      animate="show"
      exit="hide"
      custom={index}
      variants={itemAnim}
      className={cx('collection-tiled-images--product', className)}
    >
      <Link
        href={canonicalUrl(
          `/products/${
            product.slug +
            (product.surfaceOption ? `?variant=${activeVariant.id}` : '')
          }`
        )}
        scroll={false}
      >
        <a className="collection-tiled-images--content">
          <ProductTileThumbnail
            thumbnails={product.photos.listing}
            activeVariant={activeVariant}
          />
          <div className="collection-tiled-images--details">
            <h1 className="title-font text-lg font-medium text-gray-900 mb-3">
              {product.title}
            </h1>
            <ProductPrice
              price={product.price}
              comparePrice={product.comparePrice}
            />
          </div>
        </a>
      </Link>
    </m.div>
  )
}

const itemAnim = {
  initial: {
    opacity: 0,
  },
  show: (i) => ({
    opacity: 1,
    transition: {
      delay: i * 0.05 + 0.4,
      duration: 0.3,
      ease: 'linear',
    },
  }),
  hide: (i) => ({
    opacity: 0,
    transition: {
      delay: i * 0.05,
      duration: 0.3,
      ease: 'linear',
    },
  }),
}

const CollectionTiledImages = ({
  products,
  hidePagination = false,
  featuredProducts = [],
  paginationLimit = 36,
}) => {
  if (!products || products.length === 0) return null

  const { t } = useI18nContext()
  const orderedProducts = mapOrder(products, featuredProducts, 'id')

  const hasPagination = paginationLimit > 0
  const pmax = paginationLimit
  const [hasMore, setMore] = useState(products.length > pmax)
  const [pagination, setPagination] = useState([
    ...orderedProducts.slice(0, pmax),
  ])

  const productsList = hasPagination ? pagination : orderedProducts

  const loadMore = () => {
    const curPage = pagination.length
    const nextPage = orderedProducts.slice(curPage, curPage + pmax)
    const newPage = [...pagination, ...nextPage]

    if (hasMore) {
      setPagination(newPage)
      setMore(newPage.length < orderedProducts.length ? true : false)
    }
  }

  // uncomment below and assign the ref for auto-loading on scroll
  // const loadMore = useIntersection(loadMoreRef)

  // useEffect(() => {
  //   if (loadMore) {
  //     loadMore()
  //   }
  // }, [loadMore])
  return (
    <section className="collection-tiled-images">
      <div className="collection-tiled-images--products">
        {productsList.map((product, key) =>
          product.hidden || !product.visible ? null : (
            <ProductCard
              key={key}
              index={key}
              product={product}
              hasVisuals={product.photos.main || product.photos.listing}
              showGallery={product.photos.main && product.useGallery}
              showThumbs={product.photos.listing && !product.useGallery}
              showOption={product.surfaceOption}
              showPrice
            />
          )
        )}
      </div>
      {hasPagination && hasMore && !hidePagination && (
        <div className="collection--pagination">
          {hasMore && (
            <button className="btn " onClick={loadMore}>
              {t('Load more', 'さらに見る')}
            </button>
          )}
        </div>
      )}
    </section>
  )
}

function mapOrder(array, myorder, key) {
  if (!array) return

  var order = myorder.reduce((r, k, i) => ((r[k] = i + 1), r), {})
  const theSort = array.sort(
    (a, b) => (order[a[key]] || Infinity) - (order[b[key]] || Infinity)
  )
  return theSort
}

export default CollectionTiledImages
